export default __webpack_public_path__ + "static/media/img_muslinTwo_rg_p.3fcb46c9.jpg";